<template>
	<div class="app-watch" :class="routeName()">
		<div class="header">
			<sub-header :user_uid="user_uid" :watch_id="watch_id" :watch="watch" :profile="watchProfile"/>
			<sub-menu :user_uid="user_uid" :watch_id="watch_id"/>
		</div>
		<div class="body">
			<router-view :watch="watch" :profile="watchProfile"/>
		</div>
	</div>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
import ApiObject from '@/classes/api/ApiObject'
import SubHeader from './SubHeader'
import SubMenu from './SubMenu'
export default {
	components: {
		SubHeader,
		SubMenu
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			watch: new ApiObject(),
			watchProfile: new ApiObject()
		}
	},
	watch: {
		'$route' (to, from) {
			if (from.params.watch_id != to.params.watch_id) {
				this.getWatch()
			}
			this.updateHeaderBehaviour()
		}
	},
	methods: {
		getWatchPromise () {
			this.watch.loading = true
			return this.$api.watches.get(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch', 'watches.get OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('watch', 'watches.get ERROR', error)()
					this.watch.error = error
				})
				.finally(() => {
					this.watch.loading = false
				})
		},
		getWatchProfilePromise () {
			this.watchProfile.loading = true
			return this.$api.profile.get(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch', 'profile.get OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('watch', 'profile.get ERROR', error)()
					this.watchProfile.error = error
				})
				.finally(() => {
					this.watchProfile.loading = false
				})
		},
		getPicturePromise (file_uid) {
			return this.$api.files.get(this, this.user_uid, null, file_uid)
				.then(response => {
					this.$log.info('watch', 'files.get OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('watch', 'files.get ERROR', error)()
				})
		},
		getPictureMetadataPromise (file_uid) {
			return this.$api.files.getMetadata(this, this.user_uid, null, file_uid)
				.then(response => {
					this.$log.info('watch', 'files.getMetadata OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('watch', 'files.getMetadata ERROR', error)()
				})
		},
		getPicture (file_uid) {
			Promise.all([ this.getPicturePromise(file_uid), this.getPictureMetadataPromise(file_uid) ])
				.then(([ picture, metadata ]) => {
					//console.log(picture, metadata)
					this.watch.data.picture = generateBase64Picture(picture, metadata.extension)
				})
				.catch(error => {
					this.$log.error('watch', 'getWatch() ERROR', error)()
				})
		},
		getWatch () {
			Promise.all([ this.getWatchPromise(), this.getWatchProfilePromise() ])
				.then(([ watch, profile ]) => {
					//console.log(watch, profile)
					watch.picture_uid = watch.picture
					watch.picture = null
					watch.profile = profile
					this.watch.data = watch
					this.watchProfile.data = profile
					if (this.watch.data.picture_uid) {
						this.getPicture(this.watch.data.picture_uid)
					}
				})
				.catch(error => {
					this.$log.error('watch', 'getWatch() ERROR', error)()
				})
		},
		onWatchProfileUpdated () {
			this.getWatch()
		},
		// return route name, converted from camelcase to dash (hyphen)
		routeName () {
			if (!this.$route.name) {
				this.$log.error('watch', 'route with no name')()
				return 'no-name'
			}
			return this.$route.name.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
		},
		// fix header css classes
		updateHeaderBehaviour () {
			const watch = document.querySelector('.app-watch')
			const header = document.querySelector('.app-watch > .header')
			const subheader = document.querySelector('.app-watch > .header > .sub-header')
			if (header && subheader && this.$route.name === 'WatchDashboard') {
				header.classList.add('large')
				subheader.classList.add('large')
			}
			const onScroll = () => {
				if (watch.scrollTop > 50) {
					if (header.classList.contains('large')) {
						header.classList.remove('large')
					}
					if (subheader.classList.contains('large')) {
						subheader.classList.remove('large')
					}
				} else {
					if (!header.classList.contains('large')) {
						header.classList.add('large')
					}
					if (!subheader.classList.contains('large')) {
						subheader.classList.add('large')
					}
				}
			}
			if (watch && header && subheader) {
				watch.addEventListener('scroll', onScroll)
			}
		}
	},
	mounted () {
		this.$root.$on('watch-profile-updated', this.onWatchProfileUpdated)
		this.getWatch()
		this.updateHeaderBehaviour()
	},
	beforeDestroy () {
		this.$root.$off('watch-profile-updated', this.onWatchProfileUpdated)
	}
}
</script>

<style scope>
	.header {
		display: block;
		border-bottom: 0;
		min-height: unset;
	}
		.app-watch > .header {
		display: block;
		border-bottom: 0;
		min-height: unset;
	}
</style>



// WEBPACK FOOTER //
// src/components/watch/Watch.vue